import { UrlService, AuthServiceLogout } from 'services';
export function AxiosService() {
  const axios = require('axios');
  const instance = axios.create({
    baseURL: UrlService(),
    timeout: 500000,
  });

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('@token');
    const brand = localStorage.getItem('@brand');

    if (token) {
      config.headers['Authorization'] = token;
      config.headers['idBrand'] = brand;
    }
    return config;
  });

  instance.interceptors.response.use((response) => {
    return response;
  }, ((error) => {

    const notAuthorized = error.toString().includes("403");
    if (notAuthorized) {
      AuthServiceLogout();
    }
  }));

  return instance;
}
